// Diacritic-insensitive text search helpers.
//
// JavaScript string matching (`.toLowerCase().includes()` / `.indexOf()`) compares raw
// Unicode code points, so "é" (U+00E9) never matches "e" (U+0065), and a precomposed
// "É" (NFC) never matches a decomposed "É" (NFD). These helpers fold both differences so
// searching "Emile" finds "Émile" and vice versa.
//
// The OTC database already does this server-side (all text columns are utf8mb4_0900_ai_ci,
// accent-insensitive). These helpers bring the frontend's local filtering in line with it.

/**
 * Lowercase a string and strip diacritics. Decomposes via NFD (so "é" -> "e" + combining
 * accent) then removes the combining marks (U+0300–U+036F). Also collapses NFC/NFD mismatches.
 * @param {*} s
 * @returns {string}
 */
export function foldDiacritics(s) {
  return (s == null ? '' : String(s))
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

/**
 * Accent- and case-insensitive substring test.
 * @param {*} haystack
 * @param {*} needle
 * @returns {boolean}
 */
export function diacriticIncludes(haystack, needle) {
  return foldDiacritics(haystack).includes(foldDiacritics(needle))
}
